import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ROUTE } from '../../route/Route'
import Breadcrumb from '../breadcrumb/BreadCrumb'
import SeoAdd from '../Seo/SeoAdd'
import { submitAction } from '../../redux/action';
import { Email_BASE_URL } from '../../redux/common/url';

function Thankyou() {
    const {t}= useTranslation();
    const dispatch = useDispatch();
    useEffect(() => {
        window?.scrollTo(0, 0);
        // dispatch(submitAction.sendEmailAction());
        // dispatch(submitAction.sendSmsAction());
        const fetchSMS = fetch(`${Email_BASE_URL}/cronjob/notifications/sms`, {
            mode: 'no-cors'
        })
        .then(response => response.json())
        .then(data => {
            console.log('SMS Data:', data);
        })

        const fetchEmail = fetch(`${Email_BASE_URL}/cronjob/notifications/email`, {
            mode: 'no-cors'
        })
        .then(response => response.json())
        .then(data => {
            console.log('Email Data:', data);
        })

        Promise.all([fetchSMS, fetchEmail])
            .then(() => console.log('Both fetch requests completed'))
            .catch(error => console.error('Error in one or both fetch requests:', error));
        return () => { }
    }, [])
    // const scrpt = `!function(px){function e(t,e,c){var n="",r="";try{""!=(n=function(t,e){try{var c={};e.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(t,e,n){c[e]=n});return c.hasOwnProperty(t)?c[t]:""}catch(t){return""}}(t,c))?function(t,e,c){try{var n,r;c?((n=new Date).setTime(n.getTime()+864e5),r="; expires="+n.toGMTString()):r="",document.cookie=t+"="+e+r+";Path=/"}catch(t){}}(e,n,1):n=function(t){try{var e=document.cookie.match(new RegExp("(^| )"+t+"=([^;]+)"));if(e)return e[2]}catch(t){}return null}(e),r=""!=n&&null!=n?"&"+t+"="+n:"&"+t+"="}catch(t){}return r}var c="",n="",r="";try{n=e("ad","acf",c=window.location.href),r=e("col_ci","col_ci",c)}catch(t){console.log(t)}var a="https://ade.clmbtech.com/cde/eventTracking.htm?pixelId="+px+"&_w=1&_t=2"+n+r+"&rd="+(new Date).getTime();(new Image).src=a}('14428');`;
    // const noscrpt = `<img height='1' width='1' style='display:none' src='https://ade.clmbtech.com/cde/eventTracking.htm?pixelId=14428&_w=1&_t=2'/>`;
    return (
        <>
        <Helmet
          script={[{ 
            type: 'text/javascript', 
            innerHTML: "gtag('event', 'conversion', {'send_to': 'AW-674299531/LTaHCIPWw74ZEIv9w8EC'});" 
          }]}  
        />
            <SeoAdd slug={ROUTE.THANKYOU} />
            <Breadcrumb page={"Thank You"} data={{ slug: "", path: "" }} />
            <section className="thank-section">
                <div className="container">
                    <div className="tab-content">
                        <div id="organs" className="tab-pane fade in active show">
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-12">
                                    <div className="h-services">
                                        <div className="infobox_wrapper">
                                            <div className="thank_container"><img src={t("images.thank_you")} className="scale" style={{ "width": "8%" }} /></div>
                                            <h2 className="text-center mr-25">Thank You for <br /> getting in touch</h2>
                                            <div className="text-center f-16" style={{ color: "#0A0B0C" }}>Our Health Expert will reach you out soon</div>
                                            <div className="text-center mt-25">
                                                <Link to={ROUTE.HOME} className="book--hexagon active"><span>GO TO HOME</span></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <script>{scrpt}</script> */}
            {/* {noscrpt} */}
            <img height='1' width='1' src='https://ade.clmbtech.com/cde/eventTracking.htm?pixelId=14428&_w=1&_t=2' style={{ display: 'none' }} />

        </>

    )
}

export default Thankyou